import { useMemo, useEffect } from 'react';
import { onLogout, useAppDispatch } from '@wappsto/redux';
import usePrevious from './usePrevious';
import { updateStream } from '../util';

let cache: Record<string, boolean> = {};
onLogout(() => {
  cache = {};
});

interface Item {
  meta: { type: string; id: string };
}

export default function useAlwaysSubscribe(items: Item | Item[] | undefined): void {
  const dispatch = useAppDispatch();
  const arr = useMemo(() => {
    const result: string[] = [];
    if (items) {
      const allItems: Item[] = (items as any).constructor === Array ? (items as Item[]) : [items as Item];
      allItems.forEach((item) => {
        const itemPath = `/${item.meta.type}/${item.meta.id}`;
        if (!cache[itemPath]) {
          cache[itemPath] = true;
          result.push(itemPath);
        }
      });
    }
    return result;
  }, [items]);
  const prevArr = usePrevious(arr);

  useEffect(() => {
    if (prevArr) {
      prevArr.forEach((itemPath) => {
        delete cache[itemPath];
      });
      updateStream(dispatch, prevArr, 'remove');
    }

    updateStream(dispatch, arr, 'add');
  }, [items, arr, dispatch, prevArr]);
}
